// "Lad AI spille": bjælken over værktøjerne, mens AI'en har roret. Den siger, hvad AI'en gør lige nu,
// og har en stor Tag over-knap. Står hvor hintet plejer at stå; hintet tier, mens AI'en spiller.

import type { Pilot } from '../ai/pilot';
import { h, setText } from './dom';
import { ICON } from './icons';

export class PilotBar {
  readonly el: HTMLElement;
  private text = h('b', { class: 'pilot-text', 'aria-live': 'polite' });

  constructor(takeOver: () => void) {
    const btn = h('button', { type: 'button', class: 'btn primary pilot-take', onclick: () => takeOver() }, 'Tag over');
    btn.setAttribute('aria-keyshortcuts', 'A');
    btn.title = 'Tag over (A, eller bare spil selv)';
    this.el = h('div', { class: 'pilot-bar', hidden: true }, h('span', { class: 'pilot-icon', html: ICON.robot }), h('span', { class: 'pilot-what' }, h('small', {}, 'AI spiller'), this.text), btn);
  }

  update(pilot: Pilot | null, covered: boolean): void {
    this.el.hidden = !pilot || covered;
    if (!pilot || covered) return;
    const m = pilot.next ?? pilot.last;
    setText(this.text, m ? `${pilot.next ? '' : '✓ '}${m.label}` : 'Kigger på kortet …');
  }
}
